import { render, staticRenderFns } from "./Parcelas.vue?vue&type=template&id=2e7c302e&scoped=true"
import script from "./Parcelas.vue?vue&type=script&lang=js"
export * from "./Parcelas.vue?vue&type=script&lang=js"
import style0 from "./Parcelas.vue?vue&type=style&index=0&id=2e7c302e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7c302e",
  null
  
)

export default component.exports